var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeopleOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "61px",
    height: "43px",
    viewBox: "0 0 61 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/social/people_outline_24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D08C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B6B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.625,35.5 C32.3345833,35.5 36.9791667,30.8554167 36.9791667,25.1458333 C36.9791667,19.43625 32.3345833,14.7916667 26.625,14.7916667 C20.9154167,14.7916667 16.2708333,19.43625 16.2708333,25.1458333 C16.2708333,30.8554167 20.9154167,35.5 26.625,35.5 Z M26.625,20.7083333 C29.0804167,20.7083333 31.0625,22.6904167 31.0625,25.1458333 C31.0625,27.60125 29.0804167,29.5833333 26.625,29.5833333 C24.1695833,29.5833333 22.1875,27.60125 22.1875,25.1458333 C22.1875,22.6904167 24.1695833,20.7083333 26.625,20.7083333 Z M26.625,40.6770833 C19.7025,40.6770833 5.91666667,44.1383333 5.91666667,51.03125 L5.91666667,56.2083333 L47.3333333,56.2083333 L47.3333333,51.03125 C47.3333333,44.1383333 33.5475,40.6770833 26.625,40.6770833 Z M12.8391667,50.2916667 C15.3241667,48.5758333 21.3295833,46.59375 26.625,46.59375 C31.9204167,46.59375 37.9258333,48.5758333 40.4108333,50.2916667 L12.8391667,50.2916667 Z M47.4516667,40.8545833 C50.8833333,43.3395833 53.25,46.6529167 53.25,51.03125 L53.25,56.2083333 L65.0833333,56.2083333 L65.0833333,51.03125 C65.0833333,45.0554167 54.7291667,41.6533333 47.4516667,40.8545833 Z M44.375,35.5 C50.0845833,35.5 54.7291667,30.8554167 54.7291667,25.1458333 C54.7291667,19.43625 50.0845833,14.7916667 44.375,14.7916667 C42.7775,14.7916667 41.2983333,15.17625 39.9375,15.8270833 C41.80125,18.46 42.8958333,21.6845833 42.8958333,25.1458333 C42.8958333,28.6070833 41.80125,31.8316667 39.9375,34.4645833 C41.2983333,35.1154167 42.7775,35.5 44.375,35.5 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SME_Asia_B2C_Desktop_Quote_1contact",
    transform: "translate(-692.000000, -343.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(464.000000, 266.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/social/people_outline_24px",
    transform: "translate(223.000000, 63.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleOutline);
export default __webpack_public_path__ + "static/media/PeopleOutline.ae00422b26766af9a5fbacb27b596b95.svg";
export { ForwardRef as ReactComponent };